import React from 'react'
import { SidebarSubMenuProps } from './SidebarSubMenu.types'
import './SidebarSubMenu.scss'

export const SidebarSubMenu: React.FC<SidebarSubMenuProps> = ({
  items,
  activeItemId,
  onItemClick,
}) => {
  if (items.length === 0) return null

  return (
    <div className="sidebar-sub-menu">
      <div className="sidebar-sub-menu__border" />
      {items.map((item) => (
        <div
          key={item.id}
          className={`sidebar-sub-menu__item ${activeItemId === item.id ? 'sidebar-sub-menu__item--active' : ''}`}
          role="button"
          tabIndex={0}
          onClick={() => onItemClick(item.id)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onItemClick(item.id)
            }
          }}
        >
          <span className="sidebar-sub-menu__item-label">{item.label}</span>
        </div>
      ))}
    </div>
  )
}
